export function getEnv(location) {
    let env = 'local'
    if (/alfred.camera/.test(location.origin)) {
        env = 'prod'
    }
    if (/wildlands.my-alfred.com/.test(location.origin)) {
        env = 'stage'
    }
    if (
        /(wildlands[2-9]{1}|beta[1-9]{1}).my-alfred.com/.test(location.origin)
    ) {
        env = 'dev'
    }
    const alfredTest2wsxsw2 = env === 'dev' || env === 'local'

    return {
        env,
        alfredTest2wsxsw2,
    }
}

if (typeof window !== 'undefined') {
    Object.assign(window, getEnv(window.location))
}
